import React, { useRef, useState, useEffect } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import Tooltip from './../../Tooltip';
import makeStyles from './../../makeStyles/makeStylesInternal';
import useTextOverflow from '../../MasterDetail/internal/useTextOverflow';
import { spacing40, spacing60 } from './../../styles/tokens';
var useStyles = makeStyles(function () {
  return {
    root: {
      textOverflow: 'ellipsis',
      width: "calc(100% - " + spacing40 + ")",
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      position: 'relative',
      display: 'inline-block',
      pointerEvents: 'auto'
    },
    required: {
      width: "calc(100% - " + spacing60 + ")"
    },
    password: {
      width: 'calc(100% - 2rem)'
    },
    passwordRequired: {
      width: 'calc(100% - 3rem)'
    },
    onlyEndAdornment: {
      width: 'calc(100% - 0rem)'
    },
    onlyEndAdornmentRequired: {
      width: 'calc(100% - 1rem)'
    },
    labelNoOverflow: {
      display: 'initial'
    }
  };
});
var TextFieldLabel = function TextFieldLabel(props) {
  var _cn;
  var children = props.children,
    required = props.required,
    type = props.type,
    _props$InputProps = props.InputProps,
    _props$InputProps2 = _props$InputProps === void 0 ? {} : _props$InputProps,
    startAdornment = _props$InputProps2.startAdornment,
    endAdornment = _props$InputProps2.endAdornment;
  var classes = useStyles();
  var labelRef = useRef(null);
  var _useTextOverflow = useTextOverflow(labelRef),
    overflow = _useTextOverflow[0];
  var _useState = useState(''),
    overflowStyle = _useState[0],
    setOverflowStyle = _useState[1];
  useEffect(function () {
    if (!overflow) {
      setOverflowStyle(classes.labelNoOverflow);
    } else {
      setOverflowStyle('');
    }
  }, [overflow, classes.labelNoOverflow]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, overflow ? /*#__PURE__*/React.createElement(Tooltip, {
    title: children
  }, /*#__PURE__*/React.createElement("span", {
    ref: labelRef,
    className: cn(classes.root, (_cn = {}, _cn[classes.password] = type === 'password', _cn[classes.passwordRequired] = type === 'password' && required, _cn[classes.onlyEndAdornment] = !startAdornment && endAdornment && type !== 'password', _cn[classes.onlyEndAdornmentRequired] = !startAdornment && endAdornment && required, _cn[classes.required] = required, _cn))
  }, children)) : /*#__PURE__*/React.createElement("span", {
    ref: labelRef,
    className: cn(classes.root, overflowStyle)
  }, children));
};
TextFieldLabel.propTypes = {
  children: PropTypes.node,
  type: PropTypes.string,
  InputProps: PropTypes.object,
  startAdornment: PropTypes.node,
  endAdornment: PropTypes.node,
  required: PropTypes.bool
};
export default TextFieldLabel;